import { PropsWithChildren } from 'react'
import { useProductDetailsDialog } from './useProductDetailsDialog'
import { TProductDetailsDialog } from './types'
import { ProductDetailsDialogUI } from './ProductDetailsDialogUI'

export const ProductDetailsDialog = ({ productId, children }: PropsWithChildren<TProductDetailsDialog>) => {
  const props = useProductDetailsDialog({ productId })
  return <ProductDetailsDialogUI {...props}>{children}</ProductDetailsDialogUI>
}
